import Image, { ImageLoader, ImageProps } from "next/image";

const pattern = new RegExp(/https:\/\/media\.digitoon\.ir\/8\/static_files\/(?<root>\w+)\/(?<filename>\w+)\.(?<extension>\w+)/);
const imagicLoader: ImageLoader =  ({src, width, quality}) => {
    const {root, filename, extension} = pattern.exec(src).groups;

    return `/imagic/${root}/${extension}/${width}/${filename}.webp`;
}

function Imagic(props: ImageProps) {
    const UNSAFE_BYPASS_IMAGIC = false;
    if (!UNSAFE_BYPASS_IMAGIC && typeof props.src === "string" && pattern.test(props.src) && process.env.NODE_ENV !== "development") {
        return <Image {...props} loader={imagicLoader} />
    }

    return <Image {...props} />
}


export default Imagic;